export default {
	CALL: 'Call',
	VACATION: 'Vacation',
	NOT_WORKING_HOURS: 'NOT_WORKING_HOURS',
};
